export const messages = {
  en: {
    accountManage: {
      searchTitle: "Search Conditions",
      ownerAccount: "Owner Account",
      accountId: "Account ID",
      accountName: "Account Name",
      idCard: "ID Card",
      phone: "Phone",
      accountType: "Account Type",
      accountAmount: "Account Amount",
      deductionRoom: "Deduction Room",
      createTime: "Create Time",
      operations: "Operations",
      accountDetail: "Account Details",
      delete: "Delete",
      prestore: "Prestore",
      query: "Query",
      reset: "Reset",
      placeholderName: "Please enter account name",
      placeholderIdCard: "Please enter ID card number",
      placeholderLink: "Please enter contact information"
    },
    prestoreAccount: {
      title: "Prestore",
      accountType: "Account Type",
      ownerPhone: "Owner Phone",
      ownerName: "Owner Name",
      deductionRoom: "Deduction Room",
      prestoreAmount: "Prestore Amount",
      paymentMethod: "Payment Method",
      remark: "Remark",
      placeholderPhone: "Required, please enter owner phone",
      placeholderOwner: "Required, please select owner",
      placeholderRoom: "Required, please select room",
      placeholderAmount: "Required, please enter prestore amount",
      placeholderPayment: "Required, please select payment method",
      placeholderRemark: "Optional, please enter remark",
      save: "Save",
      cancel: "Cancel"
    },
    deleteAccount: {
      title: "Please confirm your operation!",
      confirmDelete: "Confirm to delete deposit?",
      cancel: "Cancel",
      confirm: "Confirm Delete"
    }
  },
  zh: {
    accountManage: {
      searchTitle: "查询条件",
      ownerAccount: "业主账户",
      accountId: "账户编号",
      accountName: "账户名称",
      idCard: "身份证号",
      phone: "手机号",
      accountType: "账户类型",
      accountAmount: "账户金额(元)",
      deductionRoom: "扣款房号",
      createTime: "创建时间",
      operations: "操作",
      accountDetail: "账户明细",
      delete: "删除",
      prestore: "预存",
      query: "查询",
      reset: "重置",
      placeholderName: "请输入账户名称",
      placeholderIdCard: "请输入身份证号",
      placeholderLink: "请输入联系方式"
    },
    prestoreAccount: {
      title: "预存",
      accountType: "账户类型",
      ownerPhone: "业主手机",
      ownerName: "业主名称",
      deductionRoom: "扣款房屋",
      prestoreAmount: "预存金额(元)",
      paymentMethod: "支付方式",
      remark: "备注",
      placeholderPhone: "必填，请填写业主手机号",
      placeholderOwner: "必填，请选择业主",
      placeholderRoom: "必填，请选择房屋",
      placeholderAmount: "必填，请填写预存金额(元)",
      placeholderPayment: "必填，请选择支付方式",
      placeholderRemark: "可填，请填写备注",
      save: "保存",
      cancel: "取消"
    },
    deleteAccount: {
      title: "请确认您的操作!",
      confirmDelete: "确定删除保证金",
      cancel: "点错了",
      confirm: "确认删除"
    }
  }
}